import React from "react";
import { Building2, MapPin, Edit2, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

export const SitesTab = ({ sites, setIsAddSiteOpen, openSiteEditor, deleteSite }) => (
  <div className="space-y-6" data-testid="admin-sites-tab">
    <div className="flex justify-between items-center">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Site Management</h2>
        <p className="text-gray-600">Manage clinical research sites</p>
      </div>
      <Button onClick={() => setIsAddSiteOpen(true)} className="flex items-center gap-2 bg-green-600 hover:bg-green-700" data-testid="add-site-btn">
        <MapPin className="h-4 w-4" /> Add New Site
      </Button>
    </div>

    <Card className="border-0 shadow-lg bg-gradient-to-br from-green-50 to-green-100">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-green-900">Total Sites</CardTitle>
        <Building2 className="h-4 w-4 text-green-600" />
      </CardHeader>
      <CardContent><div className="text-3xl font-bold text-green-900">{sites.length}</div></CardContent>
    </Card>

    <Card className="border-0 shadow-lg">
      <CardHeader className="bg-gray-50 rounded-t-lg"><CardTitle className="text-gray-900">All Sites</CardTitle></CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="text-left p-4 font-semibold text-gray-700">Site Name</th>
                <th className="text-left p-4 font-semibold text-gray-700">Location</th>
                <th className="text-left p-4 font-semibold text-gray-700">Coordinator</th>
                <th className="text-left p-4 font-semibold text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody>
              {sites.map((site, index) => (
                <tr key={site.id} className={`border-b hover:bg-gray-50 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'}`} data-testid={`site-row-${site.id}`}>
                  <td className="p-4 font-medium text-gray-900">{site.name}</td>
                  <td className="p-4 text-gray-600">{site.location}</td>
                  <td className="p-4 text-gray-600">{site.coordinator}</td>
                  <td className="p-4">
                    <div className="flex gap-2">
                      <Button size="sm" variant="outline" onClick={() => openSiteEditor(site)} className="hover:bg-green-50" data-testid={`edit-site-${site.id}`}>
                        <Edit2 className="h-3 w-3" />
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => deleteSite(site.id)} className="text-red-600 hover:text-red-700 hover:bg-red-50" data-testid={`delete-site-${site.id}`}>
                        <Trash2 className="h-3 w-3" />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  </div>
);
